<template>
  <div
    v-if="showTimer"
    class="rounded-lg bg-dark-modal mt-4"
  >
    <div class="border-bottom border-secondary font-weight-bold h5 p-3">
      Tempo
    </div>
    <div class="d-flex justify-content-center align-items-center p-3">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="28"
        height="28"
        class="mr-2"
      >
        <use xlink:href="#icon-clock" />
      </svg>
      <Timer
        v-model="timeRemaining"
        :time="challengeStartedAt"
      />
    </div>
  </div>
</template>
<script>
import HasClearRouter from '@/common/mixins/HasClearRouter.js'
import { mapActions, mapState } from 'vuex'
import Timer from './Timer'

export default {
  components: {
    Timer,
  },
  mixins: [HasClearRouter],
  data() {
    return {
      timeRemaining: 0,
    }
  },
  computed: {
    ...mapState({
      challenge : state => state.challenge.current,
    }),
    showTimer() {
      return !this.challenge.finished_at;
    },
    challengeStartedAt() {
      return this.challenge.started_at ? this.$moment(this.challenge.started_at)
        .add(this.challenge.minutes, 'minutes')
        .valueOf() : null;
    },
  },
  watch: {
    timeRemaining(value) {
      if (value < 1000 && !this.challenge.finished_at) {
        this.end()
      }
      this.$emit('input', value);
    }
  },
  methods: {
    ...mapActions(['finishChallenge']),
  }
}
</script>
